import axios, { AxiosResponse } from 'axios'
import { API_CALL_TYPE } from './API'

const CancelToken = axios.CancelToken
const axiosSource = CancelToken.source()

const getGenericHeaders = async (): Promise<Record<string, string>> => {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }
}

const makeGetApiCall = async (
  url: string,
  callback: (data: any) => void,
  errorCallBack: (error: any) => void,
  extraHeaders: Record<string, string> = {},
): Promise<void> => {
  const headers = await getGenericHeaders()
  axios
    .get(url, {
      cancelToken: axiosSource.token,
      headers: {
        ...headers,
        ...extraHeaders,
      },
    })
    .then((result: AxiosResponse) => {
      callback(result.data)
    })
    .catch((error) => {
      errorCallBack(error)
    })
}

const makePostApiCall = async (
  url: string,
  callback: (data: any) => void,
  errorCallBack: (error: any) => void,
  body: any,
  extraHeaders: Record<string, string> = {},
  formData?: any,
  isMultiPart?: false,
): Promise<void> => {
  const headers = await getGenericHeaders()
  headers['Content-Type'] = isMultiPart
    ? 'multipart/form-data'
    : formData
    ? 'multipart/form-data'
    : 'application/json'

  const authHeaders = {}
  axios
    .post(url, formData ? formData : body, {
      cancelToken: axiosSource.token,
      headers: {
        ...headers,
        ...authHeaders,
        ...extraHeaders,
      },
    })
    .then((result: AxiosResponse) => {
      callback(result.data)
    })
    .catch((error) => {
      errorCallBack(error)
    })
}
export const makeApiCall = (
  apiCallType: string,
  urlPath: string,
  callback: (data: any) => void,
  errorCallBack: (error: any) => void,
  body: any = {},
  headers: Record<string, string> = {},
  formData?: any,
  isMultiPart?: false,
): void => {
  if (apiCallType === API_CALL_TYPE.GET_CALL) {
    makeGetApiCall(urlPath, callback, errorCallBack, headers)
  } else if (apiCallType === API_CALL_TYPE.POST_CALL) {
    makePostApiCall(
      urlPath,
      callback,
      errorCallBack,
      body,
      headers,
      formData,
      isMultiPart,
    )
  }
}
